__turbopack_context__.v({
  "body": "RmI0pq_body",
  "description": "RmI0pq_description",
  "descriptionText": "RmI0pq_descriptionText",
  "heading": "RmI0pq_heading",
  "title": "RmI0pq_title",
  "wrapper": "RmI0pq_wrapper",
});
